module.exports = __webpack_public_path__ + "img/view_comfy.304011b5.svg";